module.exports = __webpack_public_path__ + "img/800_cd2.08596033.png";